/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedBlurbReturns_user$ref: FragmentReference;
export type PdpSharedBlurbReturns_user = {|
  +isVerifiedTrade: ?boolean,
  +$refType: PdpSharedBlurbReturns_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbReturns_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '871381ffb25bb95935181a3c9bb6907a';
module.exports = node;
